export const ACCESS_TOKEN_LOADED = 'Auth/accessTokenLoaded';
export const AUTHORIZATION_FAILED = 'Auth/authorizationFailed';

export const accessTokenLoaded = (token) => ({ type: ACCESS_TOKEN_LOADED, token });

export const authorizationFailed = () => ({ type: AUTHORIZATION_FAILED });
